import produce from 'immer';
import { constants_proveedores } from '../actions/constants/proveedores.constants';

const initialState = {
  proveedores: [],
  proveedoresOpto11: [],
};

export default produce((state = initialState, action) => {
  const { type, payload } = action;
  switch (type) {
    case constants_proveedores.OBTENER_PROVEEDORES_REQUEST: {
      return {
        ...state,
        proveedores: [],
      };
    }
    case constants_proveedores.OBTENER_PROVEEDORES_SUCCESS: {
      console.log(payload);
      return {
        ...state,
        proveedores: payload,
      };
    }
    case constants_proveedores.OBTENER_PROVEEDORES_FAILURE: {
      return {
        ...state,
        proveedores: [],
        error: payload.toString(),
      };
    }
    case constants_proveedores.OBTENER_PROVEEDORES_OPTO11_SUCCESS: {
      return {
        ...state,
        proveedoresOpto11: payload,
      };
    }
    default: return state;
  }
});
